import * as React from 'react';

import { cn } from '@/lib/utils';

type PanelElement =
    | 'div'
    | 'section'
    | 'article'
    | 'aside'
    | 'header'
    | 'footer'
    | 'main';

interface PanelProps extends React.ComponentProps<'div'> {
    as?: PanelElement;
    /** @deprecated Chamfers were retired in the SnappyTrade redesign; ignored. */
    chamfer?: 'none' | 'asymmetric' | 'asymmetric-sm' | 'notched';
    /** @deprecated HUD decorations were retired in the SnappyTrade redesign; ignored. */
    decoration?: 'none' | 'brackets' | 'target' | 'cropmarks';
    /** @deprecated Ignored (see `decoration`). */
    decorationColor?: string;
}

function Panel({
    className,
    // Retired visual props, accepted for call-site compatibility.
    chamfer: _chamfer,
    decoration: _decoration,
    decorationColor: _decorationColor,
    as: Component = 'div',
    children,
    style,
    ...props
}: PanelProps) {
    return (
        <Component
            data-slot="panel"
            className={cn(
                'relative overflow-hidden rounded-xl border border-border bg-card text-card-foreground',
                className,
            )}
            style={style}
            {...props}
        >
            {children}
        </Component>
    );
}

export { Panel };
